const UserInitialData = {
    skillsRestriction: [],
    vmsDate: null,
    general: {
        name: "",
        cpf: "",
        email: "",
        receiveSentryNews: false,
        profile: {
            sex: null,
            dtBirth: "",
            nationality: null,
            educationLevel: null,
            maritalStatus: null,
            mother: "",
            father: "",
            bloodFactor: "",

            sector: "",
            admission: "",
            pictureDate: "",
            leftHanded: "",
            terminationDate: "",
            contractualTerm: ""
        },
        address: {
            type: null,
            address: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            zipcode: ""
        },
        nameWar: "",
        employeeCode: "",
        rank: "",
        userTeamId: null,
        imageId: "",
        image: null,
        noCpfJustification: "",
        removeImage: false,
    },

    user: {
        status: true,
        changePassword: false,
        loginBlocked: false,
        login: "",
        password: "",
        passwordConfirm: "",
        observation: "",
        effectiveStatus: false
    },

    devices: [],
    dependents: [],

    documents: {
        rg: "",
        emitterRg: "",
        expeditionRg: "",
        rgFile: "",
        cnh: "",
        emitterCnh: "",
        expirationCnh: "",
        cnhFile: "",
        categoryCnh: [],
        workRegister: "",
        workSerie: "",
        emitterWork: "",
        workFile: "",
        pisPasep: "",
        pisFile: "",
        voterRegister: "",
        voterZone: "",
        voterSection: "",
        voterFile: "",
        carryShippingDate: "",
        carryDueDate: "",
        carryFile: "",
        cautionNumber: "",
        licenseNumber: "",
        shotShippingDate: "",
        shotDueDate: "",
        shotFile: "",
        psychoShippingDate: "",
        psychoDueDate: "",
        psychoFile: "",
        toxicologicalShippingDate: "",
        toxicologicalDueDate: "",
        toxicologicalFile: "",
        longGunLicenceShippingDate: "",
        longGunLicenceDueDate: "",
        longGunLicenceFile: "",
        crafShippingDate: "",
        crafDueDate: "",
        crafFile: "",
        reservistRaNumber: "",
        reservistDate: "",
        reservistCertificateFile: "",
    },

    trainings: [],
    conductHistory: [],
    privateWeapons: [],
    dayOff: [],
    clothes: {
        helmet: "",
        jacket: "",
        bulletproofVest: "",
        militaryBracer: "",
        elbowPad: "",
        halfFingerGlove: "",
        pants: "",
        belt: "",
        kneeBrace: "",
        sock: "",
        rainSet: "",
        shoes: "",
    },
    attachs: [],
}

export default UserInitialData;